export default "__VITE_ASSET__OqvJ8VIG__"